import { createSelector } from 'reselect';

import type { ReduxState } from '../../types/reduxTypes';
import { DebugTools } from './debugToolTypes';
import type { DebugToolSettings, DebugToolState } from './debugToolTypes';

const EMPTY_DEBUG_TOOL_STATE: DebugToolState = {};

export const selectDebugTools = (state: ReduxState): DebugToolState =>
    state.getIn(['debug', 'tools'], EMPTY_DEBUG_TOOL_STATE) as DebugToolState;

export const selectDebugToolProperties = <ToolName extends DebugTools>(toolName: ToolName) =>
    createSelector(selectDebugTools, (debugTools): DebugToolSettings[ToolName] | undefined => debugTools[toolName]);

export const selectDebugToolProperty = <
    ToolName extends DebugTools,
    PropertyName extends keyof DebugToolSettings[ToolName],
>(
    toolName: ToolName,
    property: PropertyName,
) =>
    createSelector(
        selectDebugToolProperties(toolName),
        (toolProperties): DebugToolSettings[ToolName][PropertyName] | undefined => toolProperties?.[property],
    );

export const selectDebugToolLastUpdateTime = (toolName: DebugTools) =>
    selectDebugToolProperty(toolName, 'lastUpdateTimestamp');
